import { remove, get, downloadFile } from '../helpers/api';

export const SERVICE_URI = '/portal';
export const BASE_URI = '/api/v1/orders';

export const removeFile = async (file, orderId) =>
  remove(`${SERVICE_URI}${BASE_URI}/${orderId}/files/${file.id}`);

export const getFiles = async (id, orderId) =>
  get(
    `${SERVICE_URI}${BASE_URI}/${orderId}/files/${
      Array.isArray(id) ? id.join(',') : id
    }`,
  );

export const downloadFiles = async (id, orderId) =>
  downloadFile(
    `${SERVICE_URI}${BASE_URI}/${orderId}/files/${
      Array.isArray(id) ? id.join(',') : id
    }?download`,
  )
    .then((res) => res.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      a.remove();
    });

export const downloadFilesById = async (id) =>
  downloadFile(
    `${SERVICE_URI}${BASE_URI}/files/${
      Array.isArray(id) ? id.join(',') : id
    }?download`,
  )
    .then((res) => res.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      a.remove();
    });

export const downloadInvoiceById = async (id, transactionId) =>
  downloadFile(
    `${SERVICE_URI}/api/v1/accounts/invoice/${
      Array.isArray(id) ? id.join(',') : id
    }?transactionId=${transactionId}`,
  )
    .then((res) => res.blob())
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.target = '_blank';
      document.body.appendChild(a);
      a.click();
      a.remove();
    });
